import { useState } from "react";
import { IInputProps, Input } from ".";
import { toReadablePrice } from "../../../lib/utils";

interface InputNumberProps extends IInputProps {
  onChange: (value: string) => void;
  length?: number;
  mode: "apartment" | "otp" | "price";
}

const InputNumber = ({
  onChange,
  length,
  mode = "otp",
  value,
  ...other
}: InputNumberProps) => {
  const [isFocus, setIsFocus] = useState(false);

  const handleApartmentMode = (value: string) => {
    if (value === "" || value === "0") {
      return onChange("");
    }

    const isNumber = /^(?:[1-9]\d*|0)$/;

    if (isNumber.test(value)) {
      if (length) {
        if (value.length <= length) {
          return onChange(value);
        }
        return;
      }

      return onChange(value);
    }
  };

  const handleOtpMode = (value: string) => {
    if (value === "") {
      return onChange("");
    }
    const isNumber = /^\d+$/;

    if (isNumber.test(value)) {
      if (length) {
        if (value.length <= length) {
          return onChange(value);
        }
        return;
      }

      return onChange(value);
    }
  };

  const handlePriceMode = (value: string) => {
    if (value === "") {
      return onChange("");
    }
    const isNumber = /^\d+$/;

    if (isNumber.test(value)) {
      if (length) {
        if (value.length <= length) {
          return onChange(value);
        }
        return;
      }

      return onChange(value);
    }
  };

  const handleChange = (value: string) => {
    if (mode === "otp") {
      return handleOtpMode(value);
    }
    if (mode === "apartment") {
      return handleApartmentMode(value);
    }
    if (mode === "price") {
      return handlePriceMode(value);
    }
  };

  const currentValue =
    mode === "price" && value !== undefined && !isFocus
      ? toReadablePrice(String(value))
      : value;

  return (
    <Input
      onChange={handleChange}
      {...other}
      value={currentValue}
      onFocus={() => setIsFocus(true)}
      onBlur={() => setIsFocus(false)}
    />
  );
};

export default InputNumber;
